import { DataApi } from "../../api";

const usehook = () => {

    const getAllPolicy = async ()=>{
        try {
            const response = await DataApi.getpolicy()
            return response.data;
            
        } catch (error) {
            
        }

    }
    return{
        getAllPolicy,
    }
}

export default usehook
